export function Footer() {
  return <footer className="footer">FarmaTrade — F2B Agricultural Marketplace</footer>;
}
